export const NAV_LINKS = [
  { to: "/plans", label: "Our Plans" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/delivery-areas", label: "Delivery Areas" },
  { to: "/about", label: "About Us" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

export const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/subscription-policy", label: "Subscription & Cancellation" },
  { to: "/cookie-policy", label: "Cookie Policy" },
];
